module.exports = __webpack_public_path__ + "static/media/asui-tsuyu-win.b74e4dee.png";